import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Icon, Theme } from '..';
import { Description } from './elements';
import { STATUS_ICON_NAMES } from './constants';
import { getStatusBackgroundColor } from './helpers';
/**
 * A Message displays text in one of these styles: success, info, warning or error.
 * It can have a clickable button to trigger a callback, which can update the state
 * to hide the message.
 *
 * @return {jsx}
 */

var Message = function Message(_ref) {
  var className = _ref.className,
      description = _ref.description,
      onClose = _ref.onClose,
      type = _ref.type;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    type: type
  }, /*#__PURE__*/React.createElement(Icon, {
    name: STATUS_ICON_NAMES[type],
    color: Theme.palette.white
  }), /*#__PURE__*/React.createElement(Description, null, description), onClose && /*#__PURE__*/React.createElement(Icon, {
    tabIndex: "0",
    role: "button",
    name: "cross",
    color: Theme.palette.white,
    size: "18px",
    onClick: onClose,
    "data-testid": "close-button"
  }));
};
/**
 * PropTypes Validation
 */


var func = PropTypes.func,
    oneOf = PropTypes.oneOf,
    string = PropTypes.string;
Message.propTypes = {
  /**
   * className needed by styled components
   */
  className: string,

  /**
   * Text displayed in the message box
   */
  description: string.isRequired,

  /**
   * Callback triggered when the close icon is clicked
   */
  onClose: func,

  /**
   * Type of the message box varying the style of the box
   */
  type: oneOf(['success', 'info', 'warning', 'error'])
};
/**
 * Default props
 */

Message.defaultProps = {
  className: '',
  onClose: null,
  type: 'info'
};
var styledMessage = styled(Message).withConfig({
  displayName: "Message__styledMessage",
  componentId: "l57fk6-0"
})(["display:flex;align-items:center;padding:1.3rem;border-radius:0.5rem;color:", ";cursor:pointer;", ";"], function (_ref2) {
  var palette = _ref2.theme.palette;
  return palette.white;
}, function (_ref3) {
  var theme = _ref3.theme,
      type = _ref3.type;
  return css(["background:", ";"], getStatusBackgroundColor(theme, type));
});
styledMessage.displayName = 'Message';
export default styledMessage;